import { useState } from "react"
import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'
import Loader from '../pages/Loader'

const TripUpdateActivity = ({trip, activity, activity_date, setPageDisplay}) => {
    const { dispatch } = useCurrentTripContext()
    const { user } = useAuthContext()
    const [activity_type, setActivityType] = useState(activity.activity_type || '') 
    const [location_name, setLocationName] = useState(activity.location_name || '')
    const [start_time, setStartTime] = useState(activity.start_time || '') 
    const [end_time, setEndTime] = useState(activity.end_time || '')
    const [location_link, setLocationLink] = useState(activity.location_link || '') 
    const [additional_details, setAdditionalDetails] = useState(activity.additional_details || '') 
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)


    if (!activity) return <Loader />

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!user) {
            return
        }
        if (!activity) {
            return
        }
        setIsLoading(true)
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/activity/` , {
            method: 'PATCH',
            body: JSON.stringify({trip_id: trip._id, activity_id: activity._id, activity_date, activity_type, location_name, start_time, end_time, location_link, additional_details}),
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        const json = await response.json() 
        
        if (!response.ok) {
            setError(json.error)
            setIsLoading(false)
        }

        if (response.ok) {
            setError(null)
            console.log('Activity updated')
            dispatch({type: 'UPDATE_ACTIVITY', payload: json})
            setIsLoading(false)
            setPageDisplay("details")
        }
    
    }   

    if (isLoading) {
        return <Loader />
    }

    return (
        <form className="add-activity-page" onSubmit={handleSubmit}>
            <h3>Update Activity</h3>

            <div className="activity-inputs">
                <div className="activity-type-name-container">
                    <div className="activity-input-container">
                        <label htmlfor="type-input">* Activity Type</label>
                        <input id="type-input" className="activity-type-input" type="text" onChange={(e) => setActivityType(e.target.value)} value={activity_type} />
                    </div>
                    <div className="activity-input-container">
                        <label htmlfor="location-input">* Location Name</label>
                        <input id="location-input" className="location-name-input" type="text" onChange={(e) => setLocationName(e.target.value)} value={location_name} />
                    </div>
                </div>
                <div className="activity-input-container start-end-time-container">
                    <div className="start-time-container">
                        <label htmlfor="start-input">* Start Time</label>
                        <input id="start-input" className="start-time-input" type="time" onChange={(e) => setStartTime(e.target.value)} value={start_time} />
                    </div>
                    <div className="end-time-container">
                        <label htmlfor="end-input">End Time</label>
                        <input id="end-input" className="end-time-input" type="time" onChange={(e) => setEndTime(e.target.value)} value={end_time} />
                    </div>
                </div>
                <div className="activity-link-additional-details-container">
                    <div className="activity-input-container">
                        <label htmlfor="link-input">Location Link</label>
                        <input id="link-input" className="location-link-input" type="text" onChange={(e) => setLocationLink(e.target.value)} value={location_link} />
                    </div>
                    <div className="activity-input-container">
                        <label htmlfor="additional-input">Additional Details:</label>
                        <textarea id="additional-input" className="additional-details-input" onChange={(e) => setAdditionalDetails(e.target.value)} value={additional_details} />
                    </div>
                </div>
                <div className="activity-form-buttons">
                    <button type="submit" className="add-activity-form-btn">Update Activity</button>
                    <button type="button" className="cancel-add-activity-btn" onClick={() => setPageDisplay("details")}>Cancel</button>
                </div>
            </div>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default TripUpdateActivity
